export enum System {
  OrderlyFor = 0,
  OrderlyForStores = 1,
  OrderlyForDistributors = 2,
}